import raw from 'raw.macro';
import * as React from 'react';

import StaticMarkdownView from './StaticMarkdownView';

export const TermsAndConditions: React.FC = () => (
  <StaticMarkdownView
    languages={{
      en: () => raw('./markdown/terms.en.md'),
      de: () => raw('./markdown/terms.de.md'),
    }}
  />
);

export const DataProtection: React.FC = () => (
  <StaticMarkdownView
    languages={{
      en: () => raw('./markdown/data_protection.en.md'),
      de: () => raw('./markdown/data_protection.de.md'),
    }}
  />
);

export const Imprint: React.FC = () => (
  <StaticMarkdownView
    languages={{
      en: () => raw('./markdown/imprint.en.md'),
      de: () => raw('./markdown/imprint.de.md'),
    }}
  />
);

export default {
  TermsAndConditions,
  DataProtection,
  Imprint,
};
